import { useSnapshot } from 'valtio';

import { listingState } from '@/states/listingState';

export const useListingState = () => useSnapshot(listingState);
